import 'babel-polyfill';

import "@fancyapps/fancybox";
import 'bootstrap';
import platform from 'platform';

import submenu from './submenu';
import SlideoutMenu from './SlideoutMenu';
import { initExcelPopup, initBankSlipPopup, Popup } from './Popup';
import initScrollingMessages from './scrollingMessages'
import toggleToast from './toast';

//vue
import VueRx from 'vue-rx';
import './vue_i18n';

Vue.use(VueRx);

//
window.toggleToast = toggleToast;

$(document).ready(function () {

    //navigationDrawer();
    submenu();

    //slide out menu
    var slideoutMenu = new SlideoutMenu($('#content-container'), $('#slideout-menu-container'));
    slideoutMenu.initSlideoutMenu();

    //------------------popup
    //excel popup
    initExcelPopup();
    //bank slip popup
    initBankSlipPopup();
    window.popups.removeItemWarningPopup = new Popup($('#remove-item-warning-popup'));
    window.popups.whatsappPopup = new Popup($('#live-chat-popup'), $('#sticker-whatsapp-btn'));
    if($('.nav-link-cart').attr('href') === '#') {
        window.popups.shoppingCartPopup = new Popup($('#shopping-cart-popup'), $('.toggle-cart-popup'));
    }
    //-------------------------

    //scrolling message
    initScrollingMessages();

    //browser detection
    if(!sessionStorage.getItem('is_show_browser_ie_popup') && platform.name === 'IE') {
        window.popups.browserIEPopup = new Popup($('#browser-ie-popup'), null, false);
        window.popups.browserIEPopup.openPopup();
        window.popups.browserIEPopup.popup.find('button').on('click', () =>sessionStorage.setItem('is_show_browser_ie_popup', true));
    }

});

import './vue_instances/shoppingCartPopup';
import './vue_instances/header';
